import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Stack, Typography, TypographyProps } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { Property } from "csstype";
import * as React from "react";

interface IProps {
    icon: IconProp;
    iconSize?: SizeProp;
    iconColor?: Property.Color;
    text: React.ReactNode;
    color?: Property.Color;
    title?: string;
    typographProps?: TypographyProps;
    onClick?: () => void;
}

export const MprcIconText: React.FC<IProps> = (props) => {
    const { icon, iconColor, title, iconSize = "sm", text, color, typographProps, onClick } = props;

    return (
        <Box title={title} className={onClick ? AppGlobalClassKeys.clickable : undefined} onClick={onClick}>
            <Stack direction="row" alignItems="center" color={color}>
                {iconColor
                    ? <Typography color={iconColor}><FontAwesomeIcon icon={icon} size={iconSize} /></Typography>
                    : <FontAwesomeIcon icon={icon} size={iconSize} />
                }
                <Box sx={{ ml: 1 }}><Typography variant="overline" color={"inherit"} {...typographProps}>{text}</Typography></Box>
            </Stack>
        </Box>
    );
};
